/**
 * @generated SignedSource<<5a753641221f536ef6d97d18e0035d00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppointmentsOrderBy = "CHARM_ID_ASC" | "CHARM_ID_DESC" | "CLINICIAN_BY_CLINICIAN_ID__CHARM_ID_ASC" | "CLINICIAN_BY_CLINICIAN_ID__CHARM_ID_DESC" | "CLINICIAN_BY_CLINICIAN_ID__CREATED_AT_ASC" | "CLINICIAN_BY_CLINICIAN_ID__CREATED_AT_DESC" | "CLINICIAN_BY_CLINICIAN_ID__EMPLOYEE_TYPE_ASC" | "CLINICIAN_BY_CLINICIAN_ID__EMPLOYEE_TYPE_DESC" | "CLINICIAN_BY_CLINICIAN_ID__ID_ASC" | "CLINICIAN_BY_CLINICIAN_ID__ID_DESC" | "CLINICIAN_BY_CLINICIAN_ID__INTRODUCTION_ASC" | "CLINICIAN_BY_CLINICIAN_ID__INTRODUCTION_DESC" | "CLINICIAN_BY_CLINICIAN_ID__SLUG_ASC" | "CLINICIAN_BY_CLINICIAN_ID__SLUG_DESC" | "CLINICIAN_BY_CLINICIAN_ID__SLUG_PUBLIC_ASC" | "CLINICIAN_BY_CLINICIAN_ID__SLUG_PUBLIC_DESC" | "CLINICIAN_BY_CLINICIAN_ID__UPDATED_AT_ASC" | "CLINICIAN_BY_CLINICIAN_ID__UPDATED_AT_DESC" | "CLINICIAN_BY_CLINICIAN_ID__USER_ID_ASC" | "CLINICIAN_BY_CLINICIAN_ID__USER_ID_DESC" | "CLINICIAN_ID_ASC" | "CLINICIAN_ID_DESC" | "CREATED_AT_ASC" | "CREATED_AT_DESC" | "ENDS_AT_ASC" | "ENDS_AT_DESC" | "ID_ASC" | "ID_DESC" | "NATURAL" | "NOTES_ASC" | "NOTES_DESC" | "PATIENT_BY_PATIENT_ID__CHARM_ID_ASC" | "PATIENT_BY_PATIENT_ID__CHARM_ID_DESC" | "PATIENT_BY_PATIENT_ID__CHARM_RECORD_ID_ASC" | "PATIENT_BY_PATIENT_ID__CHARM_RECORD_ID_DESC" | "PATIENT_BY_PATIENT_ID__CREATED_AT_ASC" | "PATIENT_BY_PATIENT_ID__CREATED_AT_DESC" | "PATIENT_BY_PATIENT_ID__ID_ASC" | "PATIENT_BY_PATIENT_ID__ID_DESC" | "PATIENT_BY_PATIENT_ID__SLUG_ASC" | "PATIENT_BY_PATIENT_ID__SLUG_DESC" | "PATIENT_BY_PATIENT_ID__UPDATED_AT_ASC" | "PATIENT_BY_PATIENT_ID__UPDATED_AT_DESC" | "PATIENT_BY_PATIENT_ID__USER_ID_ASC" | "PATIENT_BY_PATIENT_ID__USER_ID_DESC" | "PATIENT_BY_PATIENT_ID__ZOHO_ID_ASC" | "PATIENT_BY_PATIENT_ID__ZOHO_ID_DESC" | "PATIENT_ID_ASC" | "PATIENT_ID_DESC" | "PRIMARY_KEY_ASC" | "PRIMARY_KEY_DESC" | "SELECTION_METHOD_ASC" | "SELECTION_METHOD_DESC" | "SERVICE_BY_SERVICE_ID__CHARM_SERVICE_ID_ASC" | "SERVICE_BY_SERVICE_ID__CHARM_SERVICE_ID_DESC" | "SERVICE_BY_SERVICE_ID__CREATED_AT_ASC" | "SERVICE_BY_SERVICE_ID__CREATED_AT_DESC" | "SERVICE_BY_SERVICE_ID__DURATION_ASC" | "SERVICE_BY_SERVICE_ID__DURATION_DESC" | "SERVICE_BY_SERVICE_ID__ID_ASC" | "SERVICE_BY_SERVICE_ID__ID_DESC" | "SERVICE_BY_SERVICE_ID__IS_ACTIVE_ASC" | "SERVICE_BY_SERVICE_ID__IS_ACTIVE_DESC" | "SERVICE_BY_SERVICE_ID__NAME_ASC" | "SERVICE_BY_SERVICE_ID__NAME_DESC" | "SERVICE_BY_SERVICE_ID__PRICE_ASC" | "SERVICE_BY_SERVICE_ID__PRICE_DESC" | "SERVICE_BY_SERVICE_ID__SLUG_ASC" | "SERVICE_BY_SERVICE_ID__SLUG_DESC" | "SERVICE_BY_SERVICE_ID__UPDATED_AT_ASC" | "SERVICE_BY_SERVICE_ID__UPDATED_AT_DESC" | "SERVICE_ID_ASC" | "SERVICE_ID_DESC" | "STARTS_AT_ASC" | "STARTS_AT_DESC" | "STATUS_ASC" | "STATUS_DESC" | "UPDATED_AT_ASC" | "UPDATED_AT_DESC" | "USER_CHILD_BY_USER_CHILD_ID__BIRTHDATE_AT_ASC" | "USER_CHILD_BY_USER_CHILD_ID__BIRTHDATE_AT_DESC" | "USER_CHILD_BY_USER_CHILD_ID__CREATED_AT_ASC" | "USER_CHILD_BY_USER_CHILD_ID__CREATED_AT_DESC" | "USER_CHILD_BY_USER_CHILD_ID__DUE_AT_ASC" | "USER_CHILD_BY_USER_CHILD_ID__DUE_AT_DESC" | "USER_CHILD_BY_USER_CHILD_ID__ID_ASC" | "USER_CHILD_BY_USER_CHILD_ID__ID_DESC" | "USER_CHILD_BY_USER_CHILD_ID__NAME_ASC" | "USER_CHILD_BY_USER_CHILD_ID__NAME_DESC" | "USER_CHILD_BY_USER_CHILD_ID__UPDATED_AT_ASC" | "USER_CHILD_BY_USER_CHILD_ID__UPDATED_AT_DESC" | "USER_CHILD_BY_USER_CHILD_ID__USER_ID_ASC" | "USER_CHILD_BY_USER_CHILD_ID__USER_ID_DESC" | "USER_CHILD_ID_ASC" | "USER_CHILD_ID_DESC" | "%future added value";
export type PatientAppointmentsTablePaginationQuery$variables = {
  after?: any | null;
  first?: number | null;
  id: string;
  orderBy?: ReadonlyArray<AppointmentsOrderBy> | null;
};
export type PatientAppointmentsTablePaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"PatientAppointmentsTable_patient">;
  } | null;
};
export type PatientAppointmentsTablePaginationQuery = {
  response: PatientAppointmentsTablePaginationQuery$data;
  variables: PatientAppointmentsTablePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": [
    "STARTS_AT_DESC"
  ],
  "kind": "LocalArgument",
  "name": "orderBy"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PatientAppointmentsTablePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "FragmentSpread",
            "name": "PatientAppointmentsTable_patient"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "PatientAppointmentsTablePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "AppointmentsConnection",
                "kind": "LinkedField",
                "name": "appointments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppointmentsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Appointment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Clinician",
                            "kind": "LinkedField",
                            "name": "clinician",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "firstName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastName",
                                    "storageKey": null
                                  },
                                  (v8/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Service",
                            "kind": "LinkedField",
                            "name": "service",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Interval",
                                "kind": "LinkedField",
                                "name": "duration",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "days",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hours",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "minutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "months",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "seconds",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "years",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              (v8/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startsAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserChild",
                            "kind": "LinkedField",
                            "name": "userChild",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "birthdateAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dueAt",
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "filters": [
                  "orderBy"
                ],
                "handle": "connection",
                "key": "PatientAppointmentsTable_patient_appointments",
                "kind": "LinkedHandle",
                "name": "appointments"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Patient",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "48e88e07639220dfc424d1774b8db94f",
    "id": null,
    "metadata": {},
    "name": "PatientAppointmentsTablePaginationQuery",
    "operationKind": "query",
    "text": "query PatientAppointmentsTablePaginationQuery(\n  $after: Cursor\n  $first: Int\n  $orderBy: [AppointmentsOrderBy!] = [STARTS_AT_DESC]\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...PatientAppointmentsTable_patient_2IJuIk\n    id\n  }\n}\n\nfragment PatientAppointmentsTable_patient_2IJuIk on Patient {\n  appointments(first: $first, after: $after, orderBy: $orderBy) {\n    edges {\n      node {\n        clinician {\n          user {\n            firstName\n            lastName\n            slug\n            id\n          }\n          id\n        }\n        id\n        service {\n          duration {\n            days\n            hours\n            minutes\n            months\n            seconds\n            years\n          }\n          name\n          slug\n          id\n        }\n        startsAt\n        status\n        userChild {\n          birthdateAt\n          dueAt\n          name\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  user {\n    slug\n    id\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "7cfad64cb69bae591c7330ec86ae2fba";

export default node;
